import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'testmanagerprojectfilter',
  pure: false,
})
export class TestmanagerprojectfilterPipe implements PipeTransform {
  transform(
    items: any[],
    Attr: any[],
    Pri: any[],
    Cr: any[],
    Persona: any[],
    Euts: any[],
    eType: any,
    suite: any,
    type: any,
    listOfEUTs: any
  ): any {
    // console.log('Attr', Attr);
    // console.log('eType', eType);
    // console.log('Euts', Euts);
    if (type.type == 'count') {
      let count = 0;
      // if (!items || !filter) {
      //   return count;
      // }
      for (let item of items) {
        // if (item.eType === filter.eType) {
        //   count++;
        // }
      }
      return count;
    } else {
      if (!items) return [];
      return items.filter((item) => {
        // console.log('Attr', Attr.indexOf(item.tID) > -1);
        if (
          this.filterScenarios(item, suite) == true &&
          this.filterAttributes(item, Attr) == true &&
          this.filterCr(item, Cr) == true &&
          this.filterPriority(item, Pri) == true &&
          this.filterEUTs(item, Euts) == true &&
          this.filtereType(item, eType, listOfEUTs) == true &&
          this.filterModule(item, Persona, listOfEUTs) == true
        ) {
          return item;
        }
      });
      // }  && this.filterPersona(item, Persona) == true
    }
  }
  filterScenarios(item: any, suite: any) {
    if (suite.scenarios) {
      if (suite.scenarios.length > 0) {
        if (suite.scenarios.indexOf(item.scenID) > -1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  filterAttributes(item: any, Attr: any) {
    if (Attr.length > 0) {
      if (Attr.indexOf(item.attribute.symbol) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  filterCr(item: any, Cr: any) {
    if (Cr.length > 0) {
      if (Cr.indexOf(item.cr) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  filterPriority(item: any, Pri: any) {
    if (Pri.length > 0) {
      if (Pri.indexOf(item.attribute.level) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  filterEUTs(item: any, eut: any) {
    if (eut.length > 0) {
      if (eut.indexOf(item.eID) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  filtereType(item: any, type: any, listOfEUTs: any) {
    if (type.length > 0) {
      var foundEUT = listOfEUTs.find(
        (eut: any) => eut.eID == item.eID
      );
      if (type.indexOf(foundEUT.eType) > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  filterModule(item: any, Module: any, listOfEUTs: any) {
    if (Module.length > 0) {
      for (let per of Module) {
        var isPresent = listOfEUTs.find(
          (eut: any) => eut.eID == item.eID
        );
        if (isPresent.mID.indexOf(per) > -1) {
          return true;
        } else {
          // return false;
        }
      }
    } else {
      return true;
    }
    return '';
  }
}
